import {
  applySheetRowFieldPatches,
  formatSheetRowPriceInputValue,
  formatSheetRowPromotionDiscountInputValue,
  getSheetRowDefaultRawName,
  getSheetRowDescriptionSeedFromSource,
  getSheetRowPromotionSeedFromSource,
  readSheetRowOfferDefaults,
  readSheetRowPriceValue,
  readSheetRowPromotionDiscountValue,
  readSheetRowUnitDisplay,
  type SheetRematchPick,
  type SheetRowFieldPatch,
} from '../../../services/materialCommerceSheetService.ts';
import { coerceRawUnitToMaterialSelectValue } from '../../../utils/marketplace/materialUnitSelectOptions.ts';

export function priceInputValue(eff: unknown, patch: SheetRowFieldPatch | undefined): string {
  if (patch?.price !== undefined) {
    const s = String(patch.price);
    if (!s.trim()) return '';
    return s;
  }
  const n = readSheetRowPriceValue(eff);
  return n != null ? formatSheetRowPriceInputValue(n) : '';
}

export function unitInputValue(eff: unknown, patch: SheetRowFieldPatch | undefined): string {
  if (patch?.unit !== undefined) return patch.unit.trim();
  return readSheetRowUnitDisplay(eff);
}

export function unitSelectTableValue(eff: unknown, patch: SheetRowFieldPatch | undefined): string {
  return coerceRawUnitToMaterialSelectValue(unitInputValue(eff, patch));
}

export function descInputValue(row: unknown, patch: SheetRowFieldPatch | undefined): string {
  if (patch?.rawName !== undefined) return patch.rawName;
  return getSheetRowDefaultRawName(row);
}

export function descriptionOfferInputValue(row: unknown, patch: SheetRowFieldPatch | undefined): string {
  if (patch?.description !== undefined) return patch.description;
  if (row != null && typeof row === 'object' && !Array.isArray(row)) {
    const d = (row as Record<string, unknown>).description;
    if (typeof d === 'string') return d;
  }
  return getSheetRowDescriptionSeedFromSource(row);
}

export function promotionOfferInputValue(row: unknown, patch: SheetRowFieldPatch | undefined): string {
  if (patch?.promotion !== undefined) return patch.promotion;
  if (row != null && typeof row === 'object' && !Array.isArray(row)) {
    const p = (row as Record<string, unknown>).promotion;
    if (typeof p === 'string') return p;
  }
  return getSheetRowPromotionSeedFromSource(row);
}

export function promotionDiscountInputValue(eff: unknown, patch: SheetRowFieldPatch | undefined): string {
  if (patch?.promotionDiscount !== undefined) {
    const s = String(patch.promotionDiscount);
    if (!s.trim()) return '';
    return s;
  }
  const n = readSheetRowPromotionDiscountValue(eff);
  return n != null ? formatSheetRowPromotionDiscountInputValue(n) : '';
}

export function sheetReviewRowFingerprint(
  row: unknown,
  patch: SheetRowFieldPatch | undefined,
  rematchPick: SheetRematchPick
): string {
  const eff = applySheetRowFieldPatches(row, patch);
  const defs = readSheetRowOfferDefaults(eff);
  const price = readSheetRowPriceValue(eff);
  const cat = rematchPick.userCategoryId === '' ? '' : String(rematchPick.userCategoryId);
  const raw = (rematchPick.rawName ?? '').trim();
  const name = getSheetRowDefaultRawName(eff).trim();
  const unit = readSheetRowUnitDisplay(eff);
  const desc = descriptionOfferInputValue(eff, patch).trim();
  const promo = promotionOfferInputValue(eff, patch).trim();
  const pd = readSheetRowPromotionDiscountValue(eff);
  return JSON.stringify({
    price,
    unquoted: defs.unquoted,
    vat: defs.valueAddedTax,
    cat,
    raw,
    name,
    unit,
    desc,
    promo,
    pd: pd != null ? pd : null,
    createCatalog: rematchPick.createCatalogMaterial === true,
    rejectSuggested: rematchPick.rejectSuggestedCatalogMatch === true,
  });
}

export function isRowIncluded(excludedByRowIndex: Record<number, boolean> | undefined, i: number): boolean {
  return !excludedByRowIndex?.[i];
}
